import fixture from './fixture';
import steps from './steps';

const FILE_NAME = 'embroidery_smiley.png';

/**
 * Smiley Face — the follow-on lesson to the Simple Flower.
 *
 * Bundles everything tied to this one piece of artwork: the card shown in the
 * picker, the pinned palette and stitch settings the editor should start from,
 * and the walkthrough itself.
 */
const smileyTutorial = {
  id: 'smiley',
  design: {
    id: 'smiley',
    name: 'Smiley Face',
    level: 'Intermediate',
    // See `docs/tutorial-timing.md` for how this is arrived at.
    minutes: 6,
    blurb: 'Two colours, four black shapes — and two different ways of turning them into satin.',
    image: `/assets/${FILE_NAME}`,
    fileName: FILE_NAME,
    ready: true,
  },
  fixture,
  steps,
};

export default smileyTutorial;
